import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {CheckModalComponent} from '../../../check-save-modal/check-modal';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import * as _ from 'lodash';
import {PlatformsService} from '../../../../../core/services/platforms.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'platform-detail',
    templateUrl: './platform-detail.component.html',
    styleUrls: ['./platform-detail.component.scss'],
    standalone: false
})

export class PlatformDetailComponent implements OnInit {
  public returnBack;
  defaultForm;
  id;
  chosenColor;
  defColor;
  formGroup: FormGroup = new FormGroup({
    title: new FormControl('', Validators.required) ,
    description: new FormControl('') ,
    infoUrl: new FormControl('') ,
    platformUrl: new FormControl('') ,
    status: new FormControl(false)
  });
  constructor(private route: ActivatedRoute,  public dialog: MatDialog, public snackBar: MatSnackBar,
              public platformsService: PlatformsService,  private router: Router,
              public toastr: ToastrService, public translate: TranslateService) {
    this.id = this.route.snapshot.queryParamMap.get('id');
  }

  ngOnInit() {
    if (this.id) {
      this.getPlatform();
    }
  }

  getPlatform() {
    this.platformsService.getPlatformById(this.id).subscribe((res: any) => {
      if (res) {
        this.formGroup.patchValue(res);
        this.defaultForm = this.formGroup.value;
        this.defColor = res.color;
        this.chosenColor = res.color;
      }
    });
  }

  onSettingsChange(event) {
    this.chosenColor = event.bg;
  }

  addPlatform(returnToPlatform){
    const data = this.formGroup.value;
    data.id = this.id;
    if (this.id) {
      data.id = +this.id;
    }
    if (this.chosenColor) {
      data.color = this.chosenColor;
    }
    this.platformsService.addPlatform(data).subscribe((res) => {
      this.returnBack = returnToPlatform;
      if (res && returnToPlatform) {
        let text = '';
        if (this.id) {
          text = this.translate.instant('platform.platformEdited');
        } else {
          text = this.translate.instant('platform.platformAdded');
        }
        this.toastr.success(text, 'Success!');
        this.router.navigate([ './pages/settings/platforms' ]);
      }
    });
  }

  canDeactivate(): Observable<boolean> | boolean {
    return this.goBack();
  }

  goBack(): any{
    let dialogRef;
    if ((!this.compareForms() || (this.chosenColor !== this.defColor)) && !this.returnBack) {
      dialogRef = this.dialog.open(CheckModalComponent, {
        panelClass: 'unsave-form-dialog',
        width: '70vw',
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.formGroup.valid) {
            this.addPlatform(false);
            return true;
          } else {
            this.snackBar.open('Please fill forms correctly', '', {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  compareForms() {
    if (!this.id) {
      const values = Object.values(this.formGroup.value);
      const changes = values.filter(x => x && x !== '');
      return changes.length ? false : true;
    } else {
      return _.isEqual(this.formGroup.value , this.defaultForm);
    }
  }
}
